enum UserSettingsTabTypeEnum {
  YouTubeSearch = "YouTubeSearch",
  FavoritePlayList = "FavoritePlayList",
  ReadMe = "ReadMe",
  Users = "Users",
}

export default UserSettingsTabTypeEnum;
